<template>
  <div>
    <back-profile @click.native="navigateTo('app.profile.home')"
      >Perfil de {{ studentProfile.student.name }}</back-profile
    >

    <!-- Active alerts -->
    <block>
      <template slot="header"
        >Alertas ({{ activeAlerts.length }})</template
      >
      <template slot="actions">
        <button
          class="button is-primary is-outlined"
          @click="navigateTo('app.profile.raise_alert')"
        >
          + Agregar
        </button>
      </template>
      <item-list :items="activeAlerts" @item-selected="goToAlert" :key-field="'id'">
        <template slot="title" slot-scope="{ item }">{{ alertTitle(item) }}</template>
        <template slot="description" slot-scope="{ item }">{{
          item.createdAt | humanizeDate
        }}</template>
      </item-list>
    </block>

    <br />

    <!-- Inactive alerts -->
    <block>
      <template slot="header"
        >Alertas cerradas</template
      >
      <item-list
        v-if="inactiveAlerts.length"
        :items="inactiveAlerts"
        @item-selected="goToAlert"
        :key-field="'id'"
      >
        <template slot="title" slot-scope="{ item }">{{ alertTitle(item) }}</template>
        <template slot="description" slot-scope="{ item }">
          <div>
            <div>{{ item.createdAt | humanizeDate }}</div>
            <div v-if="item.finishedBy" style="margin-top: 5px; font-size: 12px; color: #666;">
              Finalizada por: <strong>{{ item.finishedBy.name }}</strong>
              <span v-if="item.finishedAt"> el {{ item.finishedAt | formatDate }}</span>
            </div>
            <div
              v-if="item.finishComment"
              style="margin-top: 5px; font-size: 12px; color: #666; font-style: italic;"
            >
              {{ item.finishComment }}
            </div>
          </div>
        </template>
      </item-list>
      <p v-else>Sin registros.</p>
    </block>
  </div>
</template>

<script>
import gql from "graphql-tag"
import LIST_ALERT from "./graphql/ListAlert.gql"
import moment from "moment"
import Block from "@/components/_base/Block.vue"
import BackProfile from "@/components/_base/BackProfile.vue"
import ItemList from "@/components/_base/ItemList.vue"

export default {
  props: {
    studentId: {
      type: String
    }
  },
  data() {
    return {
      isEnrollmentLoaded: false,
      enrollmentId: null,

      studentProfile: {
        student: {
          name: ""
        }
      },

      studentAlerts: [],

      riskFactorsLabels: {
        ACADEMIC: "Académico",
        ECONOMIC: "Económico",
        VOCATIONAL: "Vocacional",
        INSTITUTIONAL: "Institucional",
        PERSONAL: "Personal",
        OTHER: "Otro",
        VBG: "VBG"
      }
    }
  },
  mounted() {
    const currentEnrollment = window.localStorage.getItem("currentEnrollment")

    if (currentEnrollment) {
      const { enrollmentId, studentId } = JSON.parse(currentEnrollment)

      if (studentId === this.studentId) {
        this.enrollmentId = enrollmentId
      }
    }

    this.isEnrollmentLoaded = true
  },
  apollo: {
    studentProfile: {
      query: gql`
        query StudentName($studentId: ID!) {
          studentProfile(studentId: $studentId) {
            student {
              id
              name
            }
          }
        }
      `,
      variables() {
        return {
          studentId: this.studentId
        }
      }
    },
    studentAlerts: {
      query: LIST_ALERT,
      fetchPolicy: "network-only",
      variables() {
        return {
          studentId: this.studentId,
          enrollmentId: this.enrollmentId || undefined
        }
      },
      skip() {
        return !this.isEnrollmentLoaded
      }
    }
  },
  components: {
    Block,
    ItemList,
    BackProfile
  },
  computed: {
    activeAlerts() {
      return this.studentAlerts.filter(alert => alert.isActive)
    },
    inactiveAlerts() {
      return this.studentAlerts.filter(alert => !alert.isActive)
    }
  },
  methods: {
    humanizeRiskFactor(code) {
      return this.riskFactorsLabels[code] || code
    },

    alertTitle(alert) {
      // If the alert has a type, use that
      if (alert.alertType) {
        return alert.alertType.name
      }
      const labels = alert.riskFactors.map(this.humanizeRiskFactor)
      const temp = labels.join(", ") || "*Alerta sin factor de riesgo*"
      if (alert.isManual) {
        return `Alerta manual - ${temp}`
      } else {
        return temp
      }
    },

    navigateTo(route) {
      this.$emit("hello", route)
    },
    goToAlert(alert) {
      this.$emit("hello", {
        state: "app.profile.alert",
        params: {
          alertId: alert.id
        }
      })
    }
  },
  filters: {
    humanizeRiskFactor(code) {},

    humanizeDate(date) {
      if (date == null) {
        return "-"
      } else {
        const m = moment(date)
        return m.fromNow()
      }
    },
    formatDate(date) {
      if (date == null) {
        return "-"
      } else {
        return moment(date).format("DD/MM/YYYY")
      }
    }
  }
}
</script>
